import React from "react";
import { Button } from "../../../../../shared/Button/Button";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { EntityHeader } from "../../../../../widgets/EntityHeader/EntityHeader";
import { history } from "../../../../../history";
import { INVENTORY_ROUTES } from "../../../../../consts/routes";
import { DownloadButton } from "./shared/DownloadButton";
import { PrivilegesGuard } from "../../../../../shared/PrivilegesGuard";
import { PERMISSIONS } from "../../../../../consts/api";

/**
 * @param {object} param0
 * @param {{
 *    value: string;
 *    onChange: (value: string) => void;
 *    isLoading: boolean;
 * }} param0.search
 */
export function Header({ search }) {
  const { tInventory } = useAppTranslation.Inventory();

  return (
    <EntityHeader
      title={tInventory("pricing_variation.label")}
      searchValue={search.value}
      onChangeSearch={search.onChange}
      isSearching={search.isLoading}
      right={
        <div className="d-flex align-items-center gap-8">
          <DownloadButton searchTerm={search.value} />
          <PrivilegesGuard
            requiredPrivileges={[
              PERMISSIONS.inventory.manageInventoryVariations,
            ]}
          >
            <Button
              size="small"
              onClick={() =>
                history.push(INVENTORY_ROUTES.createPricingVariation())
              }
            >
              {tInventory("pricing_variation.create")}
            </Button>
          </PrivilegesGuard>
        </div>
      }
    />
  );
}
